import { useState } from 'react'
import { FormikError } from '@nv/basic-components'
import clsx from 'clsx'
import VoterRegistrationService from 'libs/services/src/lib/voter/VoterRegistrationService'
import { useTranslation } from 'react-i18next'
import Select from 'react-select/async'
import styles from './SearchAddressNV.module.scss'

export const SearchAddressNV = ({ formik, objFieldName }) => {
  const { t } = useTranslation()
  const [query, setQuery] = useState(formik.values[objFieldName]?.fullAddressNoUnit || '')

  const searchAddress = async () => {
    if (query) {
      const resp = await VoterRegistrationService.searchAddress(query)
      if (resp.success) return resp.data
      return []
    }
  }

  const handleSelect = (e) => {
    if (e) {
      formik.setFieldValue(`${objFieldName}.streetAddress`, e.streetAddress)
      formik.setFieldValue(`${objFieldName}.city`, e.city)
      formik.setFieldValue(`${objFieldName}.province`, e.province)
      formik.setFieldValue(`${objFieldName}.formattedAddress`, e.fullAddressNoUnit)
      formik.setFieldValue(`${objFieldName}._id`, e._id)
      formik.setFieldValue(`${objFieldName}.value`, e)
      formik.setFieldValue(`${objFieldName}.district`, e.district)
      formik.setFieldValue(`${objFieldName}.districts`, e.districts)
    } else {
      formik.setFieldValue(`${objFieldName}.streetAddress`, '')
      formik.setFieldValue(`${objFieldName}.city`, '')
      formik.setFieldValue(`${objFieldName}.province`, '')
      formik.setFieldValue(`${objFieldName}.postalCode`, '')
      formik.setFieldValue(`${objFieldName}.formattedAddress`, '')
      formik.setFieldValue(`${objFieldName}._id`, '')
      formik.setFieldValue(`${objFieldName}.value`, null)
      formik.setFieldValue(`${objFieldName}.district`, '')
      formik.setFieldValue(`${objFieldName}.districts`, [])
    }
  }
  return (
    <div className={clsx(styles.container)}>
      <div className={clsx(styles.label, styles.required)}>{t('registration.searchAddress')}</div>
      <Select
        className={styles['select']}
        noOptionsMessage={() => t('form.select.noOptions')}
        loadOptions={searchAddress}
        onChange={handleSelect}
        placeholder={t('registration.searchAddress')}
        isClearable
        onInputChange={setQuery}
        value={formik.values[objFieldName]?.value}
        styles={{
          control: (base, state) => ({
            ...base,
            height: '43px',
            minHeight: '43px',
            border: state.isFocused ? '2px solid var(--color-black)' : 'unset',
            boxShadow: state.isFocused ? 'var(--highlighted-box-shadow)' : 'none',
          }),
        }}
      />
      <FormikError formik={formik} fieldName={`${objFieldName}.streetAddress`} />
    </div>
  )
}
